<script>
import { parseLocalDate } from '@/utils'

export default {
  name: 'PrettyDateRange',

  props: {
    start: {
      type: String,
      default: null,
    },
    end: {
      type: String,
      default: null,
    },
  },

  computed: {
    text() {
      const start = parseLocalDate(this.start)
      const end = parseLocalDate(this.end)

      if (!start && !end) {
        return 'Dates TBA'
      }

      if (start && end) {
        const sameYear = start.getFullYear() === end.getFullYear()
        const sameMonth = start.getMonth() === end.getMonth()

        const formatShort = (date, withYear) =>
          date.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            ...(withYear ? { year: 'numeric' } : {}),
          })

        const formatFull = (date) =>
          date.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })

        if (sameYear && sameMonth) {
          const year = start.getFullYear()
          return `${formatShort(start, false)} - ${end.getDate()}, ${year}`
        }

        if (sameYear) {
          const year = start.getFullYear()
          return `${formatShort(start, false)} - ${formatShort(end, false)}, ${year}`
        }

        return `${formatFull(start)} - ${formatFull(end)}`
      }

      const single = (start || end)?.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })

      return single || 'Dates TBA'
    },
  },
}
</script>

<template>
  <span class="pretty-date-range">
    {{ text }}
  </span>
</template>

<style scoped>
.pretty-date-range {
  white-space: nowrap;
}
</style>
